import { fromJS } from 'immutable';

import * as actionTypes from './actionTypes';

const initialState = fromJS({
  consoleCommandLogList: {
    order: [],
    items: {},
    meta: { page: 1, limit: 10, total: 0 },
  },
});

export default (state = initialState, { type, data }) => {
  switch (type) {
    case actionTypes.FETCH_CONSOLE_COMMAND_LOG_LIST_SUCCESS:
      return state.merge(fromJS({ consoleCommandLogList: data }));

    default:
      return state;
  }
};
